import styled from "styled-components";
import { theme } from "../../../config";
import { Button } from "../../atoms/Button";

export const Main = styled.div`
  ${theme.mainContainerStyle}

  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media ${theme.breakpoints.mobileAndTablet} {
    ${theme.hideScrollbar}
  }
`;

export const Logo = styled.img`
  position: fixed;
  width: 164px;
  height: auto;
  left: 44px;
  top: 44px;

  @media ${theme.breakpoints.mobileAndTablet} {
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 145px;
  }
`;

export const Container = styled.div`
  margin-top: 50px;
  width: 620px;

  .ant-form-item-label > label {
    display: none;
  }

  .ant-form input[type="file"] {
    display: none;
  }

  @media ${theme.breakpoints.mobileAndTablet} {
    margin-top: 80px;
    width: 100%;
  }
`;

export const Title = styled.p`
  font-family: Orkney Medium;
  font-size: 34px;
  font-weight: 700;
  line-height: 48px;
  text-align: center;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 21.6px;
    line-height: 26px;
  }
`;

export const StepsDiv = styled.div`
  // margin: 0px 35px 0px 35px;

  @media ${theme.breakpoints.mobileAndTablet} {
    margin-left: 15px;
    margin-right: 15px;
  }
`;

export const Content = styled.div`
  margin-top: 36px;
  background-color: ${theme.colors.white};
  padding: 34px 100px 47px 100px;
  border-radius: 8px;
  ${theme.defaultContainerBoxShadow}

  @media ${theme.breakpoints.mobileAndTablet} {
    border-radius: 0;
    margin-top: 20px;
    padding: 0px 16px 10px 16px;
  }
`;

export const ButtonsWrapper = styled.div`
  text-align: center;
  margin: 35px 0 35px 0;

  #grayButton {
    background-color: ${theme.colors.neutral.black6};
    border: 1.5px solid ${theme.colors.neutral.black6};
  }

  #grayButton:hover {
    background-color: ${theme.colors.neutral.black7};
    border: 1.5px solid ${theme.colors.neutral.black7};
  }

  #grayButton:focus {
    background-color: ${theme.colors.neutral.black5};
    border: 1.5px solid ${theme.colors.neutral.black5};
  }

  @media ${theme.breakpoints.mobileAndTablet} {
    margin: 26px 0 26px 0;
  }
`;

export const ButtonStyled = styled(Button)`
  margin: 10px;
`;
